
import { defineComponent, onMounted } from 'vue'
import PaymentAdminApi from '@/core/services/payment/PaymentAdminApi'
import { usePaginatedList } from '@/core/composables/usePaginatedList'
import { formatDate, formatDateTime, formatMoney } from '@/core/helpers/paymentFormat'
import { orderStatusLabels, payerTypeLabels, toOptions } from '@/core/services/payment/labels'
import { AdminOrder } from '@/core/services/payment/types'
import PaymentListLayout from '@/core/components/payment/PaymentListLayout.vue'
import PaymentStatusTag from '@/core/components/payment/PaymentStatusTag.vue'
import NewTabLink from '@/core/components/payment/NewTabLink.vue'

export default defineComponent({
  name: 'OrdersList',
  components: { PaymentListLayout, PaymentStatusTag, NewTabLink },
  setup() {
    const list = usePaginatedList<AdminOrder>(PaymentAdminApi.orders.list, {
      defaults: {
        number: '',
        user_id: '',
        status: [],
        payer_type: '',
        created_from: '',
        created_to: '',
        amount_from: '',
        amount_to: '',
        gateway_transaction_id: '',
        unpaid: false,
        stuck: false,
        overdue_invoice: false,
      },
    })
    onMounted(list.init)

    /** Действующий (не аннулированный) счёт заказа юрлица. */
    const invoiceOf = (order: AdminOrder) =>
      order.documents.find(d => d.type === 'invoice' && d.status !== 'cancelled')

    return {
      ...list,
      statusOptions: toOptions(orderStatusLabels),
      payerOptions: toOptions(payerTypeLabels),
      payerLabels: payerTypeLabels,
      invoiceOf,
      money: formatMoney,
      date: formatDate,
      dateTime: formatDateTime,
    }
  },
})
